import { Link, tokens, Typography, Flex } from '@sapphire-react/core';
import { useTranslation } from 'react-i18next';

const paragraphs = ['shared:moreInformation.items.loanInsurance.paragraph1'];
const externalLink = 'shared:moreInformation.items.loanInsurance.link';

const CreateSectionContent = () => {
  const { t } = useTranslation();

  return (
    <>
      <Typography.Body>{t(paragraphs[0])}</Typography.Body>
      <Link marginTop={tokens.size.spacingMd}>
        <a
          target={'_blank'}
          rel={'noreferrer'}
          href={
            'https://danskebank.se/privat/produkter/bolan/relaterat/laneskydd#calc'
          }
        >
          {t(externalLink)}
        </a>
      </Link>
      <Typography.Body marginTop={tokens.size.spacingMd}>{t('shared:moreInformation.termsAndConditions.title')}</Typography.Body>
      <Flex marginTop={tokens.size.spacing2xs} flexDirection={'column'}>
        <Link >
          <a
            href={t('shared:moreInformation.termsAndConditions.link1')}
            target={'_blank'}
            rel={'noopener noreferrer'}
          >
            {t('shared:moreInformation.termsAndConditions.title1')}
          </a>
        </Link>
        <Link>
          <a
            href={t('shared:moreInformation.termsAndConditions.link2')}
            target={'_blank'}
            rel={'noopener noreferrer'}
          >
            {t('shared:moreInformation.termsAndConditions.title2')}
          </a>
        </Link>
        <Link>
          <a
            href={t('shared:moreInformation.termsAndConditions.link3')}
            target={'_blank'}
            rel={'noopener noreferrer'}
          >
            {t('shared:moreInformation.termsAndConditions.title3')}
          </a>
        </Link>
      </Flex>
    </>
  );
};

export const loanInsuranceData = {
  key: 'loan-insurance-data',
  text: 'shared:moreInformation.items.loanInsurance.title',
  content: <CreateSectionContent />,
};
